<div class="flex items-center justify-between rounded-lg border border-gray-3 bg-white py-1 pr-4">
  <div
    class="flex min-w-[260px] flex-col items-start px-4 text-sm"
    [ngClass]="{
      'text-info-600': prescription().type === 'Drugs',
      'text-warning-600': prescription().type === 'InstrumentalDiagnostic',
      'text-success-600': prescription().type === 'LaboratoryService',
      'text-purple-600': prescription().type === 'Appointment' || prescription().type === 'PersonalDoctorAppointment',
    }"
  >
    <prescriptions-icon [prescriptionType]="prescription().type"></prescriptions-icon>
    <span class="overflow-hidden text-ellipsis text-sm font-medium text-gray-2">{{ prescription().name || "Без назви" }}</span>
  </div>
  @if (prescription().franchise || prescription().franchise === 0) {
    <div class="min-w-[130px]">
      <shared-info-badge
        [color]="badgeColors.Blue"
        [withBorder]="true"
        [fontSize]="'text-sm'"
        [text]="'prescription.label.franchise' | translate: { percentage: prescription().franchise }"
      ></shared-info-badge>
    </div>
  }
</div>
